export default {
      id: "notification-disabled-outline-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#notification-disabled-outline-usage",
      toString: function () {
        return this.url;
      }
    }